import { MotionReveal } from './MotionReveal';

interface PageHeroProps {
  eyebrow: string;
  title: string;
  description: string;
}

export function PageHero({ eyebrow, title, description }: PageHeroProps) {
  return (
    <section className="border-b border-border bg-surface-muted pb-16 pt-30 sm:pb-20 sm:pt-36 lg:pb-24 lg:pt-40">
      <div className="site-container">
        <MotionReveal className="grid gap-7 lg:grid-cols-[1.05fr_0.75fr] lg:items-end lg:gap-20">
          <div>
            <p className="section-label">{eyebrow}</p>
            <h1 className="mt-3 text-balance text-5xl font-semibold tracking-[-0.055em] text-text-primary sm:text-6xl lg:text-7xl">
              {title}
            </h1>
          </div>
          <p className="max-w-xl text-pretty text-base leading-7 text-text-secondary sm:text-lg lg:pb-1">
            {description}
          </p>
        </MotionReveal>
      </div>
    </section>
  );
}

